/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notes1/view.blocks to change it.
import Add from './Add/index'
import Notes from './Notes/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Notes1({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes"
  
}) {
  return (<React.Fragment
>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
<Add
  viewPath={`${viewPath}/Add`}
/>
{children}
</React.Fragment>)
}